window.addEventListener("load", () => {
    let label; 
    let bgColor = '#224697';
    
    const solid = document.getElementById("solid")
    const contrast = document.getElementById("contrast")
    const pattern = document.getElementById("pattern")
    const select = document.getElementById("select-style")
    const title = document.getElementById("dtc-title-2").innerText
    
    
    if (title.indexOf('Patterns') !== -1) {
        label = 'Select Style: PATTERN'
        pattern.style.backgroundColor = bgColor;
        pattern.style.color = '#ffffff';

        solid.addEventListener('click', () => {
            pattern.style.backgroundColor = '#ffffff';
            pattern.style.color = '#000000';
          })
          
          contrast.addEventListener('click', () => {
            pattern.style.backgroundColor = '#ffffff';
            pattern.style.color = '#000000';
          })

    } else if (title.indexOf('Solids') !== -1) {
        label = 'Select Style: SOLID'
        solid.style.backgroundColor = bgColor;
        solid.style.color = '#ffffff';

        pattern.addEventListener('click', () => {
            solid.style.backgroundColor = '#ffffff';
            solid.style.color = '#000000';
          })
          
          contrast.addEventListener('click', () => {
            solid.style.backgroundColor = '#ffffff';
            solid.style.color = '#000000';
          })

    } else if (title.indexOf('Contrast') !== -1) {
        label = 'Select Style: CONTRAST'
        contrast.style.backgroundColor = bgColor;
        contrast.style.color = '#ffffff';
    
        
        pattern.addEventListener('click', () => {
            contrast.style.backgroundColor = '#ffffff';
            contrast.style.color = '#000000';
          })
          
        solid.addEventListener('click', () => {
            contrast.style.backgroundColor = '#ffffff';
            contrast.style.color = '#000000';
          })
    } 
    
    if(select){
      select.innerHTML = label
    }
})
